/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "contract IWETH",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "attestToken",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "chainId_",
                type: "uint16",
            },
        ],
        name: "bridgeContracts",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "completeTransferAndUnwrapETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "createWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        name: "encodeAssetMeta",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        name: "encodeTransfer",
        outputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "isTransferCompleted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "isWrappedAsset",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "outstandingBridged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseAssetMeta",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "decimals",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "symbol",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "name",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.AssetMeta",
                name: "meta",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseRegisterChain",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainID",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.RegisterChain",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseTransfer",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "payloadID",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "tokenAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "tokenChain",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint16",
                        name: "toChain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "fee",
                        type: "uint256",
                    },
                ],
                internalType: "struct BridgeStructs.Transfer",
                name: "transfer",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encoded",
                type: "bytes",
            },
        ],
        name: "parseUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "newContract",
                        type: "bytes32",
                    },
                ],
                internalType: "struct BridgeStructs.UpgradeContract",
                name: "chain",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "registerChain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVm",
                type: "bytes",
            },
        ],
        name: "updateWrapped",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "recipientChain",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "recipient",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "arbiterFee",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
        ],
        name: "wrapAndTransferETH",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "tokenChainId",
                type: "uint16",
            },
            {
                internalType: "bytes32",
                name: "tokenAddress",
                type: "bytes32",
            },
        ],
        name: "wrappedAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "testNewImplementationActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "WETH",
                type: "address",
            },
        ],
        name: "testUpdateWETHAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
var MockBridgeImplementation__factory = /** @class */ (function (_super) {
    __extends(MockBridgeImplementation__factory, _super);
    function MockBridgeImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockBridgeImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockBridgeImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockBridgeImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockBridgeImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockBridgeImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    MockBridgeImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    MockBridgeImplementation__factory.bytecode = _bytecode;
    MockBridgeImplementation__factory.abi = _abi;
    return MockBridgeImplementation__factory;
}(ContractFactory));
export { MockBridgeImplementation__factory };
